var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4839 9.22581H9.82129L9.58645 8.99935C10.4084 8.04323 10.9032 6.80194 10.9032 5.45161C10.9032 2.44065 8.46258 0 5.45161 0C2.44065 0 0 2.44065 0 5.45161C0 8.46258 2.44065 10.9032 5.45161 10.9032C6.80194 10.9032 8.04323 10.4084 8.99935 9.58645L9.22581 9.82129V10.4839L11.7419 13L13 11.7419L10.4839 9.22581ZM5.45161 9.22581C3.36323 9.22581 1.67742 7.54 1.67742 5.45161C1.67742 3.36323 3.36323 1.67742 5.45161 1.67742C7.54 1.67742 9.22581 3.36323 9.22581 5.45161C9.22581 7.54 7.54 9.22581 5.45161 9.22581Z",
    fill: "#007CA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSearchIcon);
export default __webpack_public_path__ + "static/media/BlueSearchIcon.b5522b0ee7ecd96fa411c08ea8b3a897.svg";
export { ForwardRef as ReactComponent };